import React, { useState } from "react";
import { getCachedScript } from "../../utils/scriptCache.js";
import { loadLocalModule } from "../../utils/nodeLoader.js";
import { traceFusionExport } from "../../utils/traceShapes.js";

// "Export Template (Beta2)": the AE2DRP export, one step, no options. After Effects collects the open, saved project
// (exportDavinciTemplateBeta2: the export JSON in the temp folder), then the panel's Node module buildDavinciTemplate
// (the AE2DRP bundle: ae2-authors AE2DRP/bundle.js) writes "<project> DR.dra" (project.drp + MediaFiles) next to the
// .aep. DaVinci Resolve: Project Manager > Import. Rendered shape layers are traced here first (traceFusionExport).
function ExportTemplateBeta2({ selectedTag, buttonTags, generateButtonTags, button, buttonViewMode }) {
  const [isExporting, setIsExporting] = useState(false);

  if (selectedTag && !buttonTags.includes(selectedTag)) {
    return null;
  }

  const exportTemplate = () => {
    if (isExporting) return;
    if (!getCachedScript()) {
      alert("After Effects script is not loaded");
      return;
    }
    setIsExporting(true);

    window.jsx.evalScript("run(exportDavinciTemplateBeta2());", (result) => {
      let info = null;
      try {
        if (!result || result === "false") return; // the host showed the reason
        try {
          info = JSON.parse(result);
        } catch (error) {
          throw new Error(`After Effects returned: ${result}`);
        }
        const builder = loadLocalModule("buildDavinciTemplate");
        if (!builder || typeof builder.buildDavinciTemplate !== "function") {
          throw new Error("Module buildDavinciTemplate is not available");
        }
        const report = builder.buildDavinciTemplate({
          input: info.input,
          output: info.output,
          name: info.name,
          trace: traceFusionExport,
        });
        const s = report.stats || {};
        const counts = `texts ${s.texts || 0}, media ${s.media || 0}, nested ${s.nested || 0}, solids ${s.solids || 0}, shapes ${s.shapes || 0}`;
        alert(`DaVinci template created:\n${info.output}\n(${counts})`);
        // the folder of the .dra
        const folder = info.output.replace(/[\\/][^\\/]*$/, "");
        window.__adobe_cep__.evalScript(`Folder(${JSON.stringify(folder)}).execute()`, () => {});
      } catch (error) {
        alert(`DaVinci template export failed: ${error.message}`);
      } finally {
        if (info && info.input) {
          try {
            window.cep.fs.deleteFile(info.input);
          } catch (error) {
            // the export JSON in the temp folder: left there when it cannot be removed
          }
        }
        setIsExporting(false);
      }
    });
  };

  return (
    <li className={`button-card button-card--${buttonViewMode || "list"}`} onClick={exportTemplate}>
      <div className="button-card__icon">
        <div dangerouslySetInnerHTML={{ __html: button.icon }} />
      </div>
      <div className="button-card__title">{isExporting ? "Exporting..." : button.name}</div>
      {generateButtonTags()}
    </li>
  );
}

export default ExportTemplateBeta2;
